module.exports = __webpack_public_path__ + "img/img6.328b244a.jpg";